import React, {useEffect, useState, useRef} from 'react';
import Autocomplete from './Autocomplete';
import Disclaimer from './Disclaimer';

export default function EmailAutocomplete(props) {
    const { updateEmailValue, emailValue, id, placeHolder, onClickProp, errorCorreoMessage } = props;

    const [state, setState] = useState({
        id: id,
        email: emailValue ? emailValue : '',
        placeHolder: placeHolder ? placeHolder : 'Correo Electrónico',
        suggestEmails: []
    });

    const referAutocomplete = useRef();
    const EXP_CORREO = /^[a-zA-Z0-9\-._@]+$/;

    function generateSuggest(value) {
        const nickName = value.split('@')[0];
        return [{email: `${nickName}@gmail.com`}, {email: `${nickName}@outlook.com`}, {email: `${nickName}@yahoo.com`}, {email: `${nickName}@hotmail.com`}];
    }

    function getSuggestionsEmail(value) {
        setState({...state, errorCorreo: ''});
        const escapedValue = value.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        if (escapedValue.includes('@')) {
          const regex = new RegExp('^' + escapedValue, 'i');
          const datos = generateSuggest(value);
          return datos.filter((item) => regex.test(item.email));
        }
        return [];
    }

    function onSelectedEmail(data) {
        if(validEmail(data.email)) {
            emitEmailValue(data.email);
        }else {
            emitEmailValue(null);
        }
        
    }

    function onBlurEmail(texto) {
        if(validEmail(texto)) {
            emitEmailValue(texto);
        } else {
            emitEmailValue(null);
        }
    }

    function emitEmailValue(email) {
        if(email) {
            updateEmailValue({'target': {'id': state.id, 'value': email}});
        } else {
            updateEmailValue(null);
        }
       
    }

    function validEmail(emailText) {
        const reC = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        const isInvalid = emailText === '' || (emailText !== '' && !emailText.match(reC));
        setState({...state, errorCorreo: isInvalid ? 'Es necesario que ingreses un correo válido.' : ''});
        referAutocomplete.current.setClassName(!isInvalid);
        return !isInvalid;
        //saveData('correoInvalido', isCorreoInvalido);
    }

    useEffect(() => {
        if(errorCorreoMessage!==''){
            referAutocomplete.current.setClassName(false);
        }
        if (state.email.length > 0) {
            validEmail(state.email);
        } else {
          //saveData('correoInvalido', true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [errorCorreoMessage]);

    function onClick(event){
        if(onClickProp){
            onClickProp(event);
        }
    }

    return (
        <div className='flex flex-col relative'>
            <Autocomplete
                ref={referAutocomplete}
                id={state.id}
                name={state.id}
                getSuggestions={getSuggestionsEmail}
                placeholder={state.placeHolder}
                onSelected={onSelectedEmail}
                onBlur={onBlurEmail}
                text={state.email}
                error={errorCorreoMessage}
                pattern={EXP_CORREO}
                onClick={onClick}
            />
            {(state.errorCorreo !== '' || errorCorreoMessage!=='') && <Disclaimer mensaje={errorCorreoMessage !== ''?errorCorreoMessage:state.errorCorreo} error={errorCorreoMessage !== ''?errorCorreoMessage:state.errorCorreo} />}
        </div>
    );
}